/* Independent instances; static content stays complete without JavaScript. */
(() => {
 if (customElements.get('az-brand-story')) return;
 customElements.define('az-brand-story',class extends HTMLElement {
  connectedCallback() {
   this.cleanup();
   this.lifecycle=new AbortController(); const options={signal:this.lifecycle.signal};
   this.reduced=matchMedia('(prefers-reduced-motion: reduce)'); this.fine=matchMedia('(hover: hover) and (pointer: fine)');
   this.photo=this.querySelector('.az-story__photo-motion'); this.animations=new Set(); this.seen ||= new WeakSet(); this.visible=true;
   this.counters=[...this.querySelectorAll('[data-value]')].map(el=>({el,text:el.dataset.value,value:/^(?:\d+|\d{1,3}(?:\.\d{3})+)$/.test(el.dataset.value)?Number(el.dataset.value.replaceAll('.','')):null}));
   this.reset();
   const stop=()=>{this.reset();this.finishReveal();this.finishCount();};
   this.reduced.addEventListener('change',stop,options); this.fine.addEventListener('change',()=>this.reset(),options);
   document.addEventListener('visibilitychange',()=>{if(document.hidden)stop();},options);
   this.closest('.shopify-section')?.addEventListener('shopify:section:select',stop,options);
   this.addEventListener('shopify:block:select',stop,options);
   this.addEventListener('pointermove',event=>{
    if(!this.canMove()||event.pointerType==='touch')return;
    const rect=this.getBoundingClientRect(),strength=Number(this.dataset.strength)||0;
    this.targetX=-(Math.max(-1,Math.min(1,(event.clientX-rect.left)/rect.width*2-1)))*strength;
    this.targetY=-(Math.max(-1,Math.min(1,(event.clientY-rect.top)/rect.height*2-1)))*strength;
    this.startMotion();
   },options);
   this.addEventListener('pointerleave',()=>{this.targetX=this.targetY=0;if(this.canMove())this.startMotion();},options);
   this.addEventListener('pointercancel',()=>this.reset(),options);
   if(!('IntersectionObserver' in window))return;
   this.visibility=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;if(!this.visible){this.reset();if(this.countFrame)this.finishCount();}});
   this.visibility.observe(this);
   this.reveal=new IntersectionObserver(entries=>entries.forEach(entry=>{
    if(!entry.isIntersecting)return;
    this.reveal.unobserve(entry.target);
    if(this.seen.has(entry.target))return;
    this.seen.add(entry.target);
    if(this.dataset.reveal!=='true'||this.reduced.matches||window.Shopify?.designMode||!entry.target.animate)return;
    const animation=entry.target.animate([{opacity:0,transform:'translateY(16px)'},{opacity:1,transform:'translateY(0)'}],{duration:Number(this.dataset.duration)||650,easing:'cubic-bezier(.2,.65,.3,1)'});
    this.animations.add(animation);animation.finished.then(()=>this.animations.delete(animation),()=>this.animations.delete(animation));
   }),{threshold:.1});
   this.querySelectorAll('[data-story-reveal]').forEach(el=>this.reveal.observe(el));
   const stats=this.querySelector('.az-story__stats');
   if(stats){this.countObserver=new IntersectionObserver(entries=>{if(entries[0].isIntersecting){this.countObserver.disconnect();this.startCount();}},{threshold:.25});this.countObserver.observe(stats);}
  }
  canMove(){return this.photo&&this.dataset.parallax==='true'&&this.fine.matches&&!this.reduced.matches&&!window.Shopify?.designMode&&!document.hidden&&this.visible;}
  startMotion(){if(!this.frame){this.last=performance.now();this.frame=requestAnimationFrame(t=>this.tick(t));}}
  tick(time){
   this.frame=0;if(!this.canMove()){this.reset();return;}
   const ratio=1-Math.exp(-Math.min(48,Math.max(1,time-this.last))/220);this.last=time;
   this.x+=(this.targetX-this.x)*ratio;this.y+=(this.targetY-this.y)*ratio;
   const moving=Math.abs(this.x-this.targetX)>.02||Math.abs(this.y-this.targetY)>.02;
   if(!moving){this.x=this.targetX;this.y=this.targetY;}
   this.photo.style.setProperty('--story-move-x',`${this.x.toFixed(2)}px`);this.photo.style.setProperty('--story-move-y',`${this.y.toFixed(2)}px`);
   if(moving)this.frame=requestAnimationFrame(t=>this.tick(t));
  }
  reset(){cancelAnimationFrame(this.frame);this.frame=0;this.x=this.y=this.targetX=this.targetY=0;this.photo?.style.removeProperty('--story-move-x');this.photo?.style.removeProperty('--story-move-y');}
  startCount(){
   if(this.counted||this.dataset.count!=='true'||this.reduced.matches||window.Shopify?.designMode||document.hidden)return;
   this.counted=true;const start=performance.now(),duration=Number(this.dataset.countDuration)||1200,format=new Intl.NumberFormat('de-DE');
   const tick=time=>{
    this.countFrame=0;const progress=Math.min(1,(time-start)/duration),eased=1-Math.pow(1-progress,3);
    this.counters.forEach(c=>{if(c.value!==null&&Number.isSafeInteger(c.value))c.el.textContent=format.format(Math.round(c.value*eased));});
    if(progress<1)this.countFrame=requestAnimationFrame(tick);else this.finishCount();
   };
   this.countFrame=requestAnimationFrame(tick);
  }
  finishCount(){cancelAnimationFrame(this.countFrame);this.countFrame=0;this.counters?.forEach(c=>{c.el.textContent=c.text;});}
  finishReveal(){this.animations?.forEach(a=>a.cancel());this.animations?.clear();}
  cleanup(){this.lifecycle?.abort();this.visibility?.disconnect();this.reveal?.disconnect();this.countObserver?.disconnect();this.reset();this.finishCount();this.finishReveal();}
  disconnectedCallback(){this.cleanup();}
 });
})();
